import { clear, el } from "./dom.js"
import { t } from "./i18n.js"
import { renderSection } from "./sections.js"

/**
 * @param {unknown} section
 * @param {{ locale?: string }} [opts]
 * @returns {HTMLElement}
 */
export function renderSectionElement(section, opts = {}) {
  return renderSection(section, opts)
}

/**
 * @param {{ sections?: unknown[] }|null|undefined} report
 * @param {ParentNode} rootEl
 * @param {{ locale?: string }} [opts]
 */
export function renderReport(report, rootEl, opts = {}) {
  if (!rootEl) return
  clear(rootEl)
  const locale = opts.locale || "ru"
  const instrumentCode = opts.instrumentCode || report?.instrument_code || ""
  const audience = opts.audience || ""
  const sections = (Array.isArray(report?.sections) ? report.sections : []).filter(
    (section) => !isMethodologyDisclaimer(section)
  )
  if (!sections.length) {
    rootEl.append(el("p", { className: "hint" }, t("unified_report.empty_sections", { locale })))
    return
  }
  for (const section of sections) {
    const node = renderSection(section, { ...opts, locale, instrumentCode, audience })
    if (node) rootEl.append(node)
  }
}

function isMethodologyDisclaimer(section) {
  if (!section || typeof section !== "object") return false
  if (section.title_key === "tests.result.controversial.title") return true
  if (section.title === "Ограничения методики") return true
  return section.data?.kind === "methodology_disclaimer"
}
